module.exports = "<div class=wrapper-helper> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input {%- uniqueIdentifier %}\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/datePicker/html/singleDatePicker.html
// module id = 1451
// module chunks = 1